<template>
  <div class="agreement_container">
    <div class="top-layout">
      <i class="el-icon-arrow-left" @click="goBack"></i>
      <div>User Agreement and Privacy Policy</div>
    </div>
    <div class="agreement-content">
      <h1>
        <strong><b>User Agreement and Privacy Policy</b></strong>
      </h1>
      <p>
        This agreement (referred to as the "Agreement") is an agreement between you and us regarding the use of the services we provide. Please carefully read the terms of this agreement and use our
        services after confirming full understanding and agreement. If you do not agree to any terms of this agreement, please do not use our services.
      </p>
      <h2>
        <strong><b>1、 Service Content</b></strong>
      </h2>
      <p>The services we provide include but are not limited to the following:</p>
      <ol>
        <li><span></span>Through our platform, you can access and use various information, resources, tools, etc.whichwe provide;</li>
        <li><span></span>You can register an account, post information, communicate and interact on our platform;</li>
        <li><span></span>We may provide other commercial or value-added services based on user needs and business development.</li>
      </ol>
      <h2>
        <strong><b>2、 User Rights and Obligations</b></strong>
      </h2>
      <h3>
        <strong><b>（1） User Rights</b></strong>
      </h3>
      <ol>
        <li><span></span>Free registration and use of our services in accordance with the law;</li>
        <li><span></span>Obtain services that meet our service standards and reasonable technical support;</li>
        <li><span></span>Provide genuine and reasonable opinions and suggestions regarding our services;</li>
        <li><span></span>Enjoy other legitimate rights and interests related to the services we provide in accordance with the law.</li>
      </ol>
      <h3>
        <strong><b>（2） User Obligations</b></strong>
      </h3>
      <ol>
        <li>
          <b><span></span></b><strong><b>Real and accurate information: </b></strong>Provide genuine, accurate, complete, and up-to-date personal information. If there is a change in personal
          information, it should be updated promptly on the platform to ensure that we can provide you with accurate information based services. For example, if you change the phone number reserved
          during registration, you should make timely modifications to avoid receiving important notifications or affecting service usage due to information errors.
        </li>
        <li>
          <b><span></span></b><strong><b>Account security maintenance: </b></strong>Keep your account and password safe. Do not disclose account and password information to any third party, and avoid
          using passwords that are too simple and easy to guess (such as consecutive numbers, birthdays, etc.). Regularly change passwords to enhance account security. You are fully responsible for
          all actions that occur under this account, including but not limited to posting content, conducting transactions, etc. For example, if your account is stolen due to disclosing your password
          to others and engaging in illegal activities, you will be responsible for the corresponding consequences.
        </li>
        <li>
          <b><span></span></b><strong><b>Legitimate use of services: </b></strong>Do not use our services to engage in any illegal activities, including but not limited to infringing on the
          intellectual property rights of others, disseminating obscene and pornographic information, engaging in fraudulent activities, publishing false advertisements, and other behaviors that
          violate laws, regulations, and social order and good customs.
        </li>
        <li>
          <b><span></span></b><strong><b>Compliance with relevant regulations:</b></strong
          >Please strictly comply with all current effective laws, regulations and policies related to our services, including but not limited to Internet information service management measures,
          network security laws, etc. At the same time, &nbsp;please also&nbsp;comply with the specific rules regarding service usage that we have established based on business needs, such as platform
          content publishing standards, community guidelines, etc.
        </li>
      </ol>
      <h2>
        <strong><b>3、 Privacy Policy</b></strong>
      </h2>
      <h3>
        <strong><b>（1） Collection and Use of Personal Information</b></strong>
      </h3>
      <ol>
        <li>
          <b><span></span></b><strong><b>Collection purpose: </b></strong>We collect and use your personal information primarily to provide you with a better service experience, including but not
          limited to identifying your identity to provide personalized services, processing your transaction requests, ensuring service security, and improving service quality. For example,
          recommending content that meets your interests and preferences, completing your shopping orders on the platform, etc.
        </li>
        <li>
          <b><span></span></b><strong><b>Scope of collection: </b></strong>The personal information we may collect includes but is not limited to your name, contact information (such as phone number,
          email address), geographic location information, account login information (such as login time, login IP address), browsing history, transaction records, etc. We will only collect and use
          your personal information within the scope necessary to achieve our service objectives, and will not excessively collect it.
        </li>
        <li>
          <b><span></span></b><strong><b>Usage: </b></strong>We will handle and protect the collected personal information properly in accordance with the requirements of laws and regulations. We may
          conduct data analysis on personal information to optimize service processes and improve service quality, but we will not use your personal information for purposes unrelated to providing
          services. For example, optimizing page layout by analyzing user browsing behavior makes it easier for you to access information.
        </li>
      </ol>
      <h3>
        <strong><b>（2） Protection measures for personal information</b></strong>
      </h3>
      <ol>
        <li>
          <b><span></span></b><strong><b>Technical measures:</b></strong
          >We adopt reasonable technical means, such as encryption technology, access control technology, etc., to protect the security of your personal information during transmission and storage,
          and prevent information from being stolen, tampered with, or leaked. For example, encrypting and storing your sensitive information (such as passwords) ensures that even if the data is
          illegally obtained, it is difficult to crack.
        </li>
        <li>
          <b><span></span></b><strong><b>Management measures: </b></strong>We have established strict internal management systems to regulate employees' access and usage permissions for personal
          information. Only authorized employees can access your personal information when necessary to fulfill their job responsibilities, and employees must comply with strict confidentiality
          obligations. If an employee violates regulations by disclosing your personal information, they will be subject to corresponding disciplinary action and legal pursuit.
        </li>
      </ol>
      <p>We promise not to disclose, sell or lease your personal information to any third party without your consent.</p>
      <h3>
        <strong><b>（3） Sharing of personal information</b></strong>
      </h3>
      <p>
        Within the scope permitted by law, we may share your personal information with third parties, provided that the third party complies with strict privacy protection regulations and takes
        necessary measures to protect the security of your personal information. For example, we may share necessary personal information with partners who provide us with technical support, logistics
        and delivery services to complete the relevant service processes. But we will bind third parties through contracts and other means to ensure that their processing of your personal information
        complies with laws, regulations, and the requirements of this privacy policy.
      </p>
      <h3>
        <strong><b>（4） Protection of Minors' Information</b></strong>
      </h3>
      <p>
        We attach great importance to the protection of personal information of minors. If you are a minor under the age of 18, you should obtain the consent of your legal guardian before using our
        services and use our services under the guidance of your guardian. We will not actively collect personal information of minors without the consent of their guardians. If we discover that
        personal information of minors has been collected without the consent of their guardians, we will promptly delete the relevant information.
      </p>
      <h2>
        <strong><b>4、 Disclaimer</b></strong>
      </h2>
      <h3>
        <strong><b>（1） Interruptions and malfunctions of services</b></strong>
      </h3>
      <p>
        During the use of our services, unforeseeable and unavoidable reasons such as network failures, maintenance upgrades, and third-party service provider issues (such as telecom operator network
        fluctuations, cloud service provider failures, etc.) may result in service interruptions or malfunctions. We will not be held responsible for any direct or indirect losses arising from this,
        such as economic losses caused by your inability to complete transactions in a timely manner due to service interruptions. But we will do our best to restore the service in the shortest
        possible time and promptly notify you of the service interruption and recovery situation through platform announcements and other means.
      </p>
      <h3>
        <strong><b>（2） Risks associated with user service usage</b></strong>
      </h3>
      <p>
        Users should pay attention to network security when using our services and avoid using our services in non secure environments (such as public networks without encryption measures, connecting
        to Wi Fi from unknown sources, etc.) to avoid risks such as information leakage and financial losses. For example, logging in to an account in an insecure network environment may result in the
        theft of the account password. Users shall bear all risks arising from the use of our services due to their own reasons (such as failure to properly store account passwords, operating in
        unsafe environments, etc.).
      </p>
      <h2>
        <strong><b>5、 Agreement amendment and termination</b></strong>
      </h2>
      <ol>
        <li>
          <b><span></span></b><strong><b>Agreement amendment: </b></strong>We have the right to modify this agreement at any time based on actual circumstances, changes in laws and regulations,
          business development needs, etc. The revised agreement will be prominently displayed on our platform at the time of notification. If you continue to use our services after the agreement is
          modified, it will be deemed that you accept the modified agreement content. If you do not agree to the revised agreement, you have the right to stop using our services.
        </li>
        <li>
          <b><span></span></b><strong><b>Agreement</b></strong
          ><strong><b>t</b></strong
          ><strong><b>ermination: </b></strong>We have the right to terminate this agreement and providing&nbsp;services to you in the following circumstances:
          <ul></ul>
        </li>
        <li>
          <span></span>You have violated the relevant provisions of this agreement regarding user obligations, and after we notified you, you have not corrected the violation within a reasonable
          period of time. For example, you have repeatedly posted illegal and irregular content, but despite our warnings, you have not corrected it.
        </li>
        <li>
          <span></span>If you engage in serious illegal or criminal activities using our services, we have the right to immediately terminate the services and report to the relevant departments in
          accordance with the law.
        </li>
        <li><span></span>Due to legal and regulatory adjustments or government requirements, we are unable to continue providing services to you.</li>
      </ol>
      <p>
        After the termination of the agreement, we will process your personal information in accordance with legal and regulatory requirements, such as deletion or anonymization. At the same time, the
        rights and obligations arising from your use of our services prior to the termination of the agreement shall not be exempted by the termination of the agreement and shall still be fulfilled in
        accordance with relevant laws, regulations, and the provisions of this agreement.
      </p>
      <h2>
        <strong><b>6、 Applicable laws and dispute resolution</b></strong>
      </h2>
      <ol>
        <li>
          <b><span></span></b><strong><b>Applicable Law: </b></strong>The interpretation, validity, and dispute resolution of this agreement shall be governed by the law of [specific applicable law
          name].
        </li>
        <li>
          <b><span></span></b><strong><b>Dispute Resolution: </b></strong>If there is a dispute between the parties regarding the content of this agreement, it shall be resolved through friendly
          negotiation first. When negotiation fails, either party has the right to file a lawsuit with the competent people's court. During the dispute resolution period, both parties shall continue
          to fulfill their other obligations as stipulated in this agreement, except for the disputed matters.
        </li>
      </ol>
      <h2>
        <strong><b>7、 Other</b></strong>
      </h2>
      <ol>
        <li>
          <span></span>This agreement constitutes the entire agreement between you and us regarding the use of our services, and supersedes any prior oral or written agreements between the parties
          regarding such services.
        </li>
        <li><span></span>The headings of each clause in this agreement are for convenience of reading only and do not affect the specific meaning and interpretation of the clauses.</li>
        <li>
          <span></span>If any provision of this Agreement is deemed invalid or unenforceable, it shall not affect the validity and enforceability of the other provisions, which shall remain valid and
          enforceable.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>Nanjing Lishui Electronics&nbsp;Research Institute Co., Ltd</p>
      <p>April 16th, 2025</p>
      <p>&nbsp;</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lang: 'zh'
    }
  },
  created() {
    this.lang = localStorage.getItem('lang') || 'zh'
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.agreement_container {
  // background: #F6F7FB;
  background: linear-gradient(180deg, #e8f1fb 0%, #ffffff 100%);
  // background-size: cover;
  width: 100%;
  height: 100vh;
  // overflow: hidden;
  // background-image: url(~@/assets/login/Maskgroup.jpg);
  // background-size: 100% 100%;
  .agreement-content {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100vh - 54px);
    overflow: auto;
    padding: 15px;
    font-family: PingFang SC;
  }
  .top-layout {
    display: flex;
    align-items: center;
    position: relative;
    height: 54px;
    .el-icon-arrow-left {
      font-size: 18px;
      font-weight: 600;
      margin-left: 15px;
      cursor: pointer;
      z-index: 10;
    }
    div {
      position: absolute;
      left: 50%;
      width: 100%;
      display: flex;
      z-index: 9;
      justify-content: center;
      align-items: center;
      transform: translate(-50%, 0);
      font-size: 16px;
      font-weight: 800;
      line-height: 28px;
      text-align: center;
      color: #171717;
    }
  }
}
</style>
